import ajax from '../utils/ajax';
import { formatImage } from '../utils/index'
import loadImageToTexture from './loadImageToTexture'
let color = ['#86B755', '#000000', '#ffffff', '#eeff00'];

function formatModelFilePath(path) {
    if (!path) {
        return '';
    }
    if (/^https?:\/\//i.test(path) || path.startsWith('//')) {
        return path;
    }
    return formatImage(path);
}

function parseJsonSafely(input) {
    if (!input) {
        return null;
    }
    try {
        return typeof input === 'string' ? JSON.parse(input) : input;
    } catch (error) {
        return null;
    }
}

async function loadResource(id) {
    let sourceData = (await ajax.get('/admin/materialManage/getById', { params: { id } })).data;
    const parsedDetail = parseJsonSafely(sourceData.detail);
    const isGlbResource =
        sourceData.classifyId1 === 1 &&
        sourceData.modelFilePath &&
        /\.glb$/i.test(sourceData.modelFilePath);
    const resourceRenderType = isGlbResource ? 'glb' : 'sprite';
    const parsedModelConfig = parseJsonSafely(sourceData.modelConfigJson)
        || (parsedDetail && parsedDetail.modelConfig)
        || {};
    let sourceDataDetail = isGlbResource
        ? {
            format: 'glb',
            url: formatModelFilePath(sourceData.modelFilePath),
            defaultScale: (parsedDetail && parsedDetail.defaultScale) || sourceData.defaultScale || 90,
            stem: (parsedDetail && parsedDetail.stem) || {
                color: '#4d6840',
                radiusStem: 2,
            },
            flower: (parsedDetail && parsedDetail.flower) || {
                radiusTop: '18',
                radiusBottom: '18',
                height: '28',
                color: '#6d8f5b',
            },
            modelConfig: parsedModelConfig,
        }
        : parsedDetail;

    if (sourceData.classifyId1 === 1 && !isGlbResource) {
        for (let key in sourceDataDetail.angles) {
            sourceDataDetail.angles[key] = sourceDataDetail.angles[key].singles;
            const item = sourceDataDetail.angles[key];
            let promiseArr = [];
            for (let faceKey in item) {
                promiseArr.push(loadImageToTexture(formatImage(item[faceKey].url)));
            }
            let res = await Promise.all(promiseArr);
            for (let faceKey in res) {
                item[faceKey].texture = res[faceKey].texture;
                item[faceKey].width = res[faceKey].width;
                item[faceKey].height = res[faceKey].height;
            }
            if (item.length === 1) {
                item.push({
                    ...item[0],
                    turn: true
                })
            }

        }

    }

    sourceData.detail = null;
    return {
        ...sourceData,
        type: sourceData.classifyId1,
        resourceRenderType,
        isGlbResource,
        detail: sourceDataDetail
    }
}


export default loadResource;
